import { render, staticRenderFns } from "./ToolHelpForum.vue?vue&type=template&id=24a5db7c&scoped=true"
import script from "./ToolHelpForum.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolHelpForum.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToolHelpForum.vue?vue&type=style&index=0&id=24a5db7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5db7c",
  null
  
)

export default component.exports